import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import 'rxjs/add/operator/map'
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private httpClient: HttpClient) { }
  getUserDataByID(user_id) {
    ////console.log("--- En servicio ---");
    return this.httpClient
      .get(environment.api.user_service + "/" + user_id
      ).pipe(
        map((data) => data) // ← opcional si no transformas
      );
  }

  saveUserData(user_data) {
    return this.httpClient
      .post(environment.api.user_service, user_data
      ).pipe(
        map((data) => data) // ← opcional si no transformas
      );
  }/*
  getUserSign(user_id) {
    ////console.log("--- En servicio ---");
    return this.httpClient
      .get(environment.api.usersSign, {
        params: {
          users_id: user_id
        }
      }
      ).pipe(
        map((data) => data) // ← opcional si no transformas
      );
  }
  postUserSign(user_data) {
    return this.httpClient
      .post(environment.api.usersSign, user_data
      ).pipe(
        map((data) => data) // ← opcional si no transformas
      );
  }
  putUserSign(user_data) {
    return this.httpClient
      .put(environment.api.usersSign, user_data
      ).pipe(
        map((data) => data) // ← opcional si no transformas
      );
  }*/
}
